<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>İlan Ekle</h3>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="category">İlan Resimleri <small>(Çoklu seçim yapılabilir)</small></label>
                  <input type="file" class="form-control custom-input" ref="images" @change="onImages" multiple>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="category">Kategori</label>
                  <select class="form-control custom-input" v-model="category">
                      <option value="" selected disabled hidden>Seçiniz...</option>
                    <option
                      v-for="category in categories"
                      :key="category.id"
                      :value="category.id"
                    >{{ category.title }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="city">Şehir</label>
                  <select class="form-control custom-input" v-model="city">
                      <option value="" selected disabled hidden>Seçiniz...</option>

                    <option v-for="city in cities" :key="city.id" :value="city.id">{{ city.name }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="title">İlan Başlığı</label>
                  <input type="text" v-model="title" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="advertiser">İlanı Veren</label>
                  <input type="text" v-model="advertiser" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="phone">Telefon</label>
                  <input type="text" v-model="phone" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="email">E-mail</label>
                  <input type="text" v-model="email" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="web">Web</label>
                  <input type="text" v-model="web" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="address">Adres</label>
                  <input type="text" v-model="address" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="content">İçerik</label>
                  <vue-editor :editorToolbar="customToolbar" v-model="content" class="editor"></vue-editor>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <button class="btn btn-success pull-right" @click="addData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
export default {
  components: { VueEditor },

  data() {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }]
      ],
      id: this.$route.params.id,
      dataImages: null,
      images: [],
      title: "",
      advertiser: "",
      content: "",
      web: "",
      email: "",
      phone: "",
      address: "",
      category: "",
      categories: [],
      city: "",
      cities: [],
      api: "adverts"
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    onImages(e) {
      let selectedFlies = e.target.files;
      if(!selectedFlies.length) {
        return false
      }
      for(let i = 0; i < selectedFlies.length; i++) {
        this.images.push(selectedFlies[i]);
      }
      // console.log(this.images)
    },
    getData() {
      this.$Progress.start();
      this.axios.get(this.api + '/create').then(response => {
        this.categories = response.data.categories
        this.cities = response.data.cities
        this.$Progress.finish()
      });
    },
    addData() {
      this.$Progress.start();
      let data = {
        title: this.title,
        advertiser: this.advertiser,
        content: this.content,
        web: this.web,
        email: this.email,
        phone: this.phone,
        address: this.address,
        category: this.category,
        city: this.city,
      }
      const formData = new FormData()
      for(let i = 0; i < this.images.length; i++)
      {
        formData.append('images[]', this.images[i])
      }
      Object.keys(data).map(e => {
          formData.append(e, data[e])
      })
      const config = { headers: { 'Content-Type': 'multipart/form-data' } }
      this.axios
        .post(this.api, formData, config)
        .then(response => {
          if (response.status == 201) {
            this.$router.push({
              name: "adverts.update",
              params: { id: response.data.id }
            });
          }
        });
    }
  }
};
</script>

<style scoped>
</style>
